// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
export default class Division extends Component {

  props: {
    title: any,
  }

  render () {
    return (
      <div className={style.firstDivisor}>
        <div className={style.firstLine}>
          <span><hr className={style.divider}/></span>
        </div>
        <div className={style.secondLine}>
          <span className={style.spanText}>{this.props.title}</span>
        </div>
        <div className={style.thirdLine}>
          <span><hr className={style.divider}/></span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Division/index.jsx